import React, { useEffect, useState } from 'react';
import { ArrowLeftIcon, FileTextIcon, PackageIcon, PencilRulerIcon, CheckIcon, PercentIcon, ShieldIcon, TentIcon, DollarSignIcon, SearchIcon, BellIcon, UserIcon, ChevronDownIcon, CalendarIcon, BarChart3Icon, HelpCircleIcon } from 'lucide-react';
import { PivotQuoteFlow } from '../components/quotes/pivot/PivotQuoteFlow';
import { SparePartsQuoteFlow } from '../components/quotes/spareparts/SparePartsQuoteFlow';
import { ProjectQuoteFlow } from '../components/quotes/project/ProjectQuoteFlow';
import { PromoCodeInput } from '../components/quotes/PromoCodeInput';
export function NewQuotePage({
  onBack,
  isEditing = false,
  quoteData = null
}) {
  const [selectedType, setSelectedType] = useState(quoteData?.type?.toLowerCase() || null);
  const [promoCode, setPromoCode] = useState<string | null>(null);
  const [isValidCode, setIsValidCode] = useState(false);
  const [discount, setDiscount] = useState<number | null>(null);
  // Determinar el título según si estamos editando o creando
  const pageTitle = isEditing ? 'Edit Quote' : 'New Quote';
  // Si estamos editando y no hay un tipo seleccionado, pero tenemos datos,
  // intentamos determinar el tipo basado en los datos
  useEffect(() => {
    if (isEditing && quoteData && !selectedType) {
      if (quoteData.pivots) {
        setSelectedType('pivot');
      } else if (quoteData.parts) {
        setSelectedType('spareparts');
      } else if (quoteData.items || quoteData.projectDetails) {
        setSelectedType('project');
      }
    }
  }, [isEditing, quoteData, selectedType]);
  const handleApplyPromoCode = (code: string) => {
    // In a real application, you would validate the code against an API
    // For this example, we'll simulate a valid code for "FERIA2025"
    if (code.toUpperCase() === 'FERIA2025') {
      setPromoCode(code);
      setIsValidCode(true);
      setDiscount(40); // 40% discount
    } else {
      setPromoCode(code);
      setIsValidCode(false);
      setDiscount(null);
    }
  };
  const handleClearPromoCode = () => {
    setPromoCode(null);
    setIsValidCode(false);
    setDiscount(null);
  };
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-11233" data-mp="3ec4mactkanfl">
      {/* Header */}
      <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-11234" data-mp="3japi801s6ky8">
        <div className="px-6 py-4 flex justify-between items-center" data-id="element-11235" data-mp="2qod813ogo0bo">
          <div className="flex items-center" data-id="element-11236" data-mp="2qm0jg7o76rpn">
            <button onClick={onBack} className="mr-3 text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-11237" data-mp="2vmesnt1jc7p9">
              <ArrowLeftIcon size={20} data-id="element-11238" data-mp="30lj12hgmy1ej" />
            </button>
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-11239" data-mp="35dj4ijvwzcfv">
              <FileTextIcon size={20} className="text-white" data-id="element-11240" data-mp="27xvkremedwxp" />
            </div>
            <div data-id="element-11241" data-mp="27vsqgie7phn6">
              <h1 className="text-xl font-bold text-white" data-id="element-11242" data-mp="2cwggb0qpfsft">{pageTitle}</h1>
              <p className="text-blue-200 text-sm hidden sm:block" data-id="element-11243" data-mp="2cudku16s973p">
                {isEditing ? `Editing Quote #${quoteData?.id || quoteData?.quoteNumber}` : 'Create a new quote for your customer'}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-11244" data-mp="kzuoq694qp7o">
            <div className="relative hidden sm:block" data-id="element-11245" data-mp="g1t6fnjj2tx9">
              <div className="relative" data-id="element-11246" data-mp="g1b01y35izbm">
                <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-11247" data-mp="b2pxhs0fg3k0" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-11248" data-mp="29mqa1gdkmxt" />
              </div>
            </div>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11249" data-mp="3temivkgzvrrp">
              <CalendarIcon size={20} data-id="element-11250" data-mp="3jijd84mxpb00" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11251" data-mp="3jj2y9u7vsfi9">
              <BarChart3Icon size={20} data-id="element-11252" data-mp="1nhhn456fgaa0" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11253" data-mp="1sdgapqjxlo9d">
              <HelpCircleIcon size={20} data-id="element-11254" data-mp="1dp25j8z1lnpn" />
            </button>
            <div className="relative" data-id="element-11255" data-mp="1inwny9t3la98">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11256" data-mp="1imvci4866lqz">
                <BellIcon size={20} data-id="element-11257" data-mp="14r9rs98yyo4d" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-11258" data-mp="19o9xuk5tjqvh">
                  3
                </span>
              </button>
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-11259" data-mp="zqlsl0al70z2">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-11260" data-mp="2p2xiqc6dzme8">
                <UserIcon size={16} className="text-white" data-id="element-11261" data-mp="ifq592ycyp3k" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-11262" data-mp="dhomkj4ugrsm">
                Daniel Alejandro
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-11263" data-mp="s72z203pvpc8" />
            </div>
            {promoCode && isValidCode && <div className="hidden md:flex items-center bg-amber-600/20 border border-amber-500/30 rounded-lg px-3 py-1.5" data-id="element-11264" data-mp="ndrq9tfcgyho">
                <PercentIcon size={16} className="text-amber-400 mr-1.5" data-id="element-11265" data-mp="x5nyhxb5a4zm" />
                <span className="text-amber-300 text-sm font-medium" data-id="element-11266" data-mp="x7qnqf4h3u3a">
                  {discount}% discount applied
                </span>
              </div>}
          </div>
        </div>
      </header>
      {/* Main content */}
      <div className="p-6 max-w-7xl mx-auto" data-id="element-11267" data-mp="3cw0gcwr9j3c0">
        {!selectedType ? <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-11268" data-mp="3cymrf6dd40yz">
            {/* Left column - Quote type selection */}
            <div className="lg:col-span-2" data-id="element-11269" data-mp="1bukh1bxf4mme">
              <div className="bg-slate-800/30 backdrop-blur-sm rounded-xl border border-blue-800/30 p-6 mb-6" data-id="element-11270" data-mp="1bvm30bfz2tiw">
                <div className="flex items-center mb-6" data-id="element-11271" data-mp="1gtno11wyl2x0">
                  <div className="p-2 bg-blue-900/50 rounded-lg mr-3" data-id="element-11272" data-mp="1kuh97nj0o3m7">
                    <FileTextIcon size={20} className="text-blue-400" data-id="element-11273" data-mp="1pu2ai4lnso23" />
                  </div>
                  <h2 className="text-xl font-bold text-white" data-id="element-11274" data-mp="1prpmpat7zjh4">
                    Select quote type
                  </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-11275" data-mp="1zr82rg60el3w">
                  <QuoteTypeCard icon={<PencilRulerIcon size={24} className="text-blue-400" data-id="element-11277" data-mp="24k16c0pqrnee" />} title="Pivot Quote" description="Create a quote for center pivot or linear irrigation systems" onClick={() => setSelectedType('pivot')} data-id="element-11276" data-mp="24j84ne5n3o34" />
                  <QuoteTypeCard icon={<PackageIcon size={24} className="text-blue-400" data-id="element-11279" data-mp="2dlhfy68qflhk" />} title="Spare Parts Quote" description="Create a quote for spare parts and components" onClick={() => setSelectedType('spareparts')} data-id="element-11278" data-mp="2dkzb4l807yy1" />
                  <QuoteTypeCard icon={<FileTextIcon size={24} className="text-blue-400" data-id="element-11281" data-mp="2nnl43uqnjdv4" />} title="Project Quote" description="Create a comprehensive quote for a complete irrigation project" onClick={() => setSelectedType('project')} data-id="element-11280" data-mp="2sklay7vbskna" />
                </div>
              </div>
              {/* Promo code input */}
              <PromoCodeInput onApply={handleApplyPromoCode} onClear={handleClearPromoCode} appliedCode={promoCode} isValid={isValidCode} discount={discount} data-id="element-11282" data-mp="2ep9enw1ium49" />
            </div>
            {/* Right column - Benefits and information */}
            <div className="bg-gradient-to-br from-blue-900/30 to-indigo-900/30 backdrop-blur-sm rounded-xl border border-blue-800/30 p-6" data-id="element-11283" data-mp="31mksr2e5zsra">
              <div className="flex items-center mb-6" data-id="element-11284" data-mp="2xliv2pzwborf">
                <div className="p-2 bg-indigo-900/50 rounded-lg mr-3" data-id="element-11285" data-mp="3u3x5e4ortbux">
                  <DollarSignIcon size={20} className="text-indigo-400" data-id="element-11286" data-mp="3pcyl6u0nvtme" />
                </div>
                <h2 className="text-xl font-bold text-white" data-id="element-11287" data-mp="cvl9r3vjus4q">Quote Benefits</h2>
              </div>
              <div className="space-y-5" data-id="element-11288" data-mp="hmbecew5iqyd">
                <BenefitItem icon={<CheckIcon size={18} className="text-green-400" data-id="element-11290" data-mp="hnusnzy8yrxi" />} title="Accurate Pricing" description="Get real-time pricing based on the latest product catalog" data-id="element-11289" data-mp="hncxz7r8glrp" />
                <BenefitItem icon={<ShieldIcon size={18} className="text-blue-400" data-id="element-11292" data-mp="7x9zwt598hmi" />} title="60-Day Validity" description="All quotes are valid for 60 days from creation" data-id="element-11291" data-mp="7vp5d3ixwyon" />
                <BenefitItem icon={<PercentIcon size={18} className="text-purple-400" data-id="element-11294" data-mp="10lp7wvpyxzoc" />} title="Volume Discounts" description="Automatic discounts applied for bulk orders" data-id="element-11293" data-mp="10kw0rtn3l85o" />
                <BenefitItem icon={<TentIcon size={18} className="text-amber-400" data-id="element-11296" data-mp="qmzpn1u5ud7k" />} title="Fair Promotions" description="Use fair codes for exclusive discounts (FERIA2025)" data-id="element-11295" data-mp="lpzkct54xehi" />
              </div>
              {/* Testimonial */}
              <div className="mt-8 bg-white/5 rounded-lg p-4 border border-white/10" data-id="element-11297" data-mp="3bcyzjgurmwct">
                <p className="text-blue-200 italic text-sm" data-id="element-11298" data-mp="1tflpugus7hao">
                  "The quoting system has streamlined our sales process and
                  increased our conversion rate by 28% in just three months."
                </p>
                <div className="flex items-center mt-3" data-id="element-11299" data-mp="22f8udbit537y">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center text-white text-xs font-bold" data-id="element-11300" data-mp="1yeoyeb9z05ne">
                    JF
                  </div>
                  <div className="ml-2" data-id="element-11301" data-mp="15q9kjs2krtdn">
                    <div className="text-white text-sm font-medium" data-id="element-11302" data-mp="15rav7vfoiduu">
                      Jose Fernando
                    </div>
                    <div className="text-blue-300 text-xs" data-id="element-11303" data-mp="1jjirlm31w2t0">
                      CEO, AiscoEurope
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> : selectedType === 'pivot' ? <PivotQuoteFlow initialData={isEditing ? quoteData : null} promoCode={promoCode} discount={isValidCode ? discount : null} data-id="element-11304" data-mp="n01o1stds16f" /> : selectedType === 'spareparts' ? <SparePartsQuoteFlow initialData={isEditing ? quoteData : null} promoCode={promoCode} discount={isValidCode ? discount : null} data-id="element-11305" data-mp="433dmzsnl3sr" /> : <ProjectQuoteFlow initialData={isEditing ? quoteData : null} promoCode={promoCode} discount={isValidCode ? discount : null} data-id="element-11306" data-mp="3r9nfc3u2mg3y" />}
      </div>
    </div>;
}
// Helper components
function QuoteTypeCard({
  icon,
  title,
  description,
  onClick
}) {
  return <button onClick={onClick} className="bg-gradient-to-br from-blue-500/10 to-indigo-500/20 hover:from-blue-500/20 hover:to-indigo-500/30 border border-blue-400/30 rounded-xl p-6 text-left transition-all hover:scale-105 hover:shadow-lg group" data-id="element-11307" data-mp="3hd0uhf1qvp1x">
      <div className="p-3 bg-blue-600/20 group-hover:bg-blue-600/30 rounded-lg inline-flex mb-4 transition-colors" data-id="element-11308" data-mp="33kuo2koe8wfo">
        {icon}
      </div>
      <h3 className="text-lg font-bold text-white mb-2" data-id="element-11309" data-mp="2ykouv02h71vh">{title}</h3>
      <p className="text-blue-200 text-sm" data-id="element-11310" data-mp="2tlvemzvt0wrm">{description}</p>
    </button>;
}
function BenefitItem({
  icon,
  title,
  description
}) {
  return <div className="flex" data-id="element-11311" data-mp="193unt1ittpys">
      <div className="mt-0.5 mr-3" data-id="element-11312" data-mp="1e376rb6kucw3">{icon}</div>
      <div data-id="element-11313" data-mp="1e1w45eovbb6k">
        <h3 className="text-white font-medium" data-id="element-11314" data-mp="1e1me5r3tp40v">{title}</h3>
        <p className="text-blue-300 text-sm mt-0.5" data-id="element-11315" data-mp="1j1qy5r3xwgvu">{description}</p>
      </div>
    </div>;
}